import React, {useState} from 'react';
import useStore, { Store } from './../store';
import ProgressBar from "src/components/PlaybackBar";
import {LIVE, REPLAY} from "src/globalVariables/globalVariables";
import DateRangePicker, { type DateRangePickerProps } from "@cloudscape-design/components/date-range-picker";

function FloatingControls() {
    const selectedStore = useStore((state) => state.selectedStore);
    const setSelectedStore = useStore((state) => state.setSelectedStore);

    const focusCustomer = useStore((state) => state.focusCustomer);
    const setFocusCustomer = useStore((state) => state.setFocusCustomer);

    const focusASIN = useStore(state => state.focusASIN);
    const setFocusASIN = useStore(state => state.setFocusASIN);

    const setLiveOrReplay = useStore(state => state.setReplayFilter);

    const tiles = useStore(state => state.asinTiles);
    const removeTiles = useStore(state => state.setTiles)

    const [showTimeStamps, setShowTimeStamps] = useState(false);
    const [timeRange, setTimeRange] = React.useState<DateRangePickerProps.AbsoluteValue>({
        type: "absolute", startDate: "2023-11-04T12:34:56", endDate: "2023-11-04T13:30:00"
    });
    const [resetPlayback, setResetPlayback] = useState(false);

    //Function to handle a change in the ASIN input
    const handleASINInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setFocusASIN(e.target.value as string);
    };

    //Function to handle the Replay button being pressed
    const handleReplayClick = () => {
        setShowTimeStamps(true);
        setLiveOrReplay(REPLAY);
    }

    //Function to handle the Live button being pressed
    const handleLiveClicked = () => {
        setShowTimeStamps(false);
        setLiveOrReplay(LIVE);
        removeTiles(tiles.filter(tile => tile.liveOrReplay !== REPLAY ));
    }

    //Function to handle a change in the Customer ID input
    const handleCustomerInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setFocusCustomer(e.target.value as string);
    };

    const isValidRange: DateRangePickerProps.ValidationFunction = (range) => {
        if (!range) {
            return {
                valid: false,
                errorMessage: 'No range selected.',
            };
        }
        if (range.type === 'absolute') {
            const [startDateWithoutTime] = range.startDate.split('T');
            const [endDateWithoutTime] = range.endDate.split('T');

            if (!startDateWithoutTime || !endDateWithoutTime) {
                return {
                    valid: false,
                    errorMessage: 'The selected date range is incomplete. Select a start and end date for the date range.',
                };
            }

            if (new Date(range.startDate).getDate() - new Date(range.endDate).getDate() > 0) {
                return {
                    valid: false,
                    errorMessage: 'The selected date range is invalid. The start date must be before the end date.',
                };
            }
        }
        return { valid: true };
    }

    const handleTimeChange = (timeRange: DateRangePickerProps.Value): void => {
        if (timeRange.type === "absolute") {
            setTimeRange(timeRange);
        } else {
            alert("No support for relative at the moment")
        }
        setResetPlayback(!resetPlayback);
    }

  return (
    <>
      <span>
          {/*Store selector dropdown are*/}
          <label htmlFor="storeSelector">Store:</label>
              <select name="storeSelector" id="storeSelector"
                      value={selectedStore}
                      onChange={e => setSelectedStore(e.target.value as Store)}>
                      {(Object.values(Store)).map((value) => (
                  <option
                      key={value} value={value}>
                      {value}
                  </option>
                ))}
              </select>
      </span>

      <span style={{marginLeft: 5, display: 'inline-block'}}>
        {/*Customer search input bar*/}
      <label htmlFor="customerInput">Customer ID:</label>
          <input name="customerInput" id="customerInput"
                 value={focusCustomer}
                 onChange={handleCustomerInputChange}
                 style={{ border: '1px solid black' }}/>
      </span>
        <span style={{marginLeft: 5, display: 'inline-block'}}>
        {/*ASIN search input bar*/}
            <label htmlFor="ASINInput">ASIN:</label>
        <input name="ASINInput" id="ASINInput"
               value={focusASIN}
               onChange={handleASINInputChange}
               style={{ border: '1px solid black' }}/>
      </span>
        {/*Timestamp inputs*/}
        {showTimeStamps ? (
            <div>
                <div style={{display: 'inline-block'}}>
                    <DateRangePicker
                      onChange={({detail}) => {
                          if (detail.value) {
                              handleTimeChange(detail.value)
                          }
                      }}
                      isValidRange={isValidRange}
                      value={timeRange}
                      rangeSelectorMode="absolute-only"
                      relativeOptions={[]}
                    />
                </div>

                <span style={{marginLeft: 5, display: 'inline-block'}}>
                    <button onClick={handleLiveClicked}>
                        Exit Replay
                    </button>
                </span>
                <ProgressBar startTime={timeRange.startDate} endTime={timeRange.endDate} reset={resetPlayback} setReset={setResetPlayback}></ProgressBar>
            </div>
        ):(
            <div>
                {/*Replay button*/}
                <span style={{marginLeft: 5, display: 'inline-block'}}>
                    <button onClick={handleReplayClick}>
                        Replay
                    </button>
                </span>
            </div>
        )
        }
    </>
  );
}

export default FloatingControls;
